import { contrastText } from '@/shared/lib/color';

import type { Label } from '@/entities/board/types';
import styles from './LabelChip.module.css';

export function LabelChip({ label, emptyName }: { label: Label; emptyName: string }) {
  return (
    <span
      className={styles.chip}
      style={{ background: label.color, color: contrastText(label.color) }}
      title={label.name || emptyName}
    >
      {label.name || ' '}
    </span>
  );
}
